var _path, _path2, _circle, _rect, _circle2, _circle3, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoaiLogotype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 18,
    viewBox: "0 0 61 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2428 17.3143H36.9285L44.1285 0.68573L51.2428 17.3143Z",
    fill: "#CBD5E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 17.3142H10.2714V11.8285L3.07143 0.771362L0.5 17.3142ZM20.043 17.3142H10.2716V11.8285L17.4716 0.77138L20.043 17.3142Z",
    fill: "#CBD5E1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.2142,
    cy: 9.00002,
    r: 8.31429,
    fill: "#CBD5E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.8141,
    y: 10.1143,
    width: 5.31429,
    height: 7.2,
    fill: "#CBD5E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.6429,
    cy: 2.05716,
    r: 1.37143,
    fill: "#CBD5E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.1285,
    cy: 2.05716,
    r: 1.37143,
    fill: "#CBD5E1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.6429,
    cy: 7.37143,
    r: 1.37143,
    fill: "#CBD5E1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.1285,
    cy: 7.37143,
    r: 1.37143,
    fill: "#CBD5E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoaiLogotype);
export default __webpack_public_path__ + "static/media/moai-logotype.be70615bcf426bab1c0d9262e3dfb1f5.svg";
export { ForwardRef as ReactComponent };